import { FormattedDate, FormattedMessage, useIntl } from "react-intl";
import type { ProjectActivityItem } from "./ProjectWorkspace";

// Was im Projekt geschehen ist, als Strom. Absichtlich NICHT die Zeitachse aus
// der Aufteilung: dort steht der Plan, hier sein Verlauf. Beide Male dieselbe
// Swimlane zu zeigen war die Doppelung, die diese Fläche überflüssig wirken liess.
//
// Datum statt "vor drei Tagen": ein Eintrag soll morgen dasselbe sagen wie heute.
//
// Gespeist wird der Strom bisher nur aus dem, was der Mensch selbst am Projekt
// ändert. Die eigentliche Aktivität - jemand erledigt seine Aufgabe, jemand
// schreibt etwas - braucht Ereignisse, die es serverseitig noch nicht gibt.

export function ProjectActivity({
  items,
  limit,
  onShowAll,
}: {
  items: readonly ProjectActivityItem[];
  /** Kurzfassung für die Übersicht; ohne Angabe steht alles da. */
  limit?: number;
  /** Nur gesetzt, wenn gekürzt wird: führt auf die eigene Fläche. */
  onShowAll?: () => void;
}) {
  const intl = useIntl();
  const shown = limit ? items.slice(-limit).reverse() : [...items].reverse();
  const hidden = limit ? Math.max(0, items.length - limit) : 0;

  if (items.length === 0) {
    return (
      <p id="project-activity-empty" className="smycles-field-meta text-ink-muted">
        <FormattedMessage
          id="project.activity.empty"
          defaultMessage="Noch nichts passiert. Hier landet, was am Projekt geschieht."
        />
      </p>
    );
  }

  return (
    <div>
      <ul className="space-y-2.5">
        {shown.map((item) => (
          <li key={item.id} id={`project-activity-item-${item.id}`} className="flex items-baseline gap-3">
            <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-ink/25" />
            <span className="smycles-field-value">{intl.formatMessage(item.message)}</span>
            <span className="smycles-field-meta text-ink-muted">
              <FormattedDate value={item.at} day="2-digit" month="2-digit" year="numeric" />
            </span>
          </li>
        ))}
      </ul>
      {hidden > 0 && onShowAll ? (
        <button
          type="button"
          onClick={onShowAll}
          className="smycles-field-meta mt-3 text-ink-muted transition hover:text-ink"
        >
          <FormattedMessage
            id="project.activity.showAll"
            defaultMessage="{count} weitere anzeigen"
            values={{ count: hidden }}
          />
        </button>
      ) : null}
    </div>
  );
}
